<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Nos activites" />
            <ActiVite />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ActiVite from '../Activite/ActiVite.vue';


export default {
    name: 'ActivitePage',
    components: {
        NavBar,
        PageTitle,
        ActiVite,
        FooterComp,
    }
}
</script>